import React from "react";
import { Link, useSearchParams, Navigate } from "react-router-dom";

const Failed = () => {
  const [searchParams] = useSearchParams();
  const isCanceled = searchParams.get("canceled");

  // Instantly redirect to homepage if accessed without the canceled parameter
  if (!isCanceled) {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      style={{
        backgroundColor: "#121212",
        minHeight: "calc(100vh - 80px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily: "inherit",
      }}
    >
      <div
        style={{
          backgroundColor: "#1a1a1a",
          border: "1px solid #333",
          borderRadius: "12px",
          maxWidth: "600px",
          width: "100%",
          padding: "50px 40px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "50px", marginBottom: "20px" }}>❌</div>
        <h1
          style={{ color: "#e74c3c", margin: "0 0 15px 0", fontSize: "2rem" }}
        >
          Payment Incomplete
        </h1>

        <p
          style={{
            fontSize: "1.1rem",
            color: "#bbb",
            lineHeight: "1.6",
            margin: "0 auto 30px auto",
          }}
        >
          Your checkout session was cancelled or the payment failed. No charges
          have been made to your account, and your training slot has not been
          reserved.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginTop: "30px",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/checkout"
            style={{
              padding: "16px 24px",
              backgroundColor: "#2ecc71" /* Changed to Green */,
              color: "#121212",
              textDecoration: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              fontSize: "1.05rem",
              flex: "1",
              minWidth: "200px",
            }}
          >
            Try Booking Again
          </Link>
          <Link
            to="/"
            style={{
              padding: "16px 24px",
              backgroundColor: "#151515",
              color: "#bbb",
              border: "1px solid #333",
              textDecoration: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              fontSize: "1.05rem",
              flex: "1",
              minWidth: "200px",
            }}
          >
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Failed;
